const STORAGE_KEY = "availableFeatureNames";

let cachedFeatureNames: string[] | null = null;

/** Read canonical feature names from memory or localStorage. */
export function getCachedFeatureNames(): string[] {
  if (cachedFeatureNames != null) return cachedFeatureNames;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Persist canonical feature names (memory + localStorage). */
export function setCachedFeatureNames(names: string[]): void {
  cachedFeatureNames = names;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(names));
  } catch {
    // ignore
  }
}

/** Clear cache (call on logout). */
export function clearCachedFeatureNames(): void {
  cachedFeatureNames = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Initial permissions map: all canonical feature keys false. Uses cached list from backend. */
export function getInitialPermissions(): Record<string, boolean> {
  const names = getCachedFeatureNames();
  return Object.fromEntries(names.map((name) => [name, false]));
}

/**
 * Feature name constants that mirror backend canonical strings.
 * Must match the backend list returned by getAllCanonicalFeatureNames().
 */
export const FEATURE_NAMES = {
  RestaurantCreationAndManagement: "Restaurant creation and management",
  MenuCreationAndManagement: "Menu creation and management",
  DigitalMenuThroughQRCode: "Digital menu through QR code",
  PaymentProcessingThroughStripe: "Payment processing",
  ReportingAndAnalytics: "Reporting and analytics",
  ComboCreationAndManagement: "Combo creation and management",
  TeamManagement: "Team management",
  SendOrderToPrinter: "Send order to printer",
  PromotionManagement: "Promotion management",
  BasicTableManagement: "Basic table management",
  AdvancedTableManagement: "Advanced Table management",
  AdvancedTipSettings: "Advanced tip settings",
  ChannelPriceOverride: "Channel-based price overrides",
  MultipleStationsAndTerminals: "Multiple stations and terminals",
  DiscountsAtCheckout: "Discounts at checkout",
  OrderDelayAndHold: "Order delay and hold",
  SpecialEventCreation: "Special event creation",
  NonEnglishLanguageSupport: "Non-English language support",
  TableManagement: "Table management",
  EmployeePayroll: "Employee payroll",
} as const;

/**
 * UI toggle: set to `true` to show the Promotions page and sidebar link again.
 */
export const SHOW_PROMOTIONS_PAGE = true;
